import { connectClearRefinements } from 'instantsearch.js/es/connectors';

// create the render function
const renderClearRefinements = (renderOptions, isFirstRender) => {
    const { hasRefinements, refine, widgetParams } = renderOptions;

    if (isFirstRender) {
        const button = document.createElement('button');
        button.innerHTML = '<svg class="inline-block w-4 h-4 mr-2.5"><use xlink:href="#icon-reset" class="fill-green"></use></svg> Reset';
        button.className = 'text-xs underline';

        button.addEventListener('click', () => {
            refine();
        });

        widgetParams.container.appendChild(button);
    }

    widgetParams.container.querySelector('button').disabled = !hasRefinements;
};

// create the custom widget
const customClearRefinements = connectClearRefinements(
    renderClearRefinements,
);

export default customClearRefinements;
